import React, { useState } from 'react';
import {
    Box,
    Grid,
    TextField,
    Typography,
    FormControlLabel,
    Checkbox,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
export default function HumanVictimInformation() {
    const [count, setCount] = useState(1);
    const handleCountChange = (e) => {
        const v = Math.max(1, parseInt(e.target.value, 10) || 1);
        setCount(v);
    };
    const theme = useTheme();
    return (
        <Box mb={4}>
            <Box
                sx={{
                    mb: 2,
                    p: 1,
                    borderRadius: 1,
                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                }}
            >
                <Typography variant="h6" color="white">
                    Human Victim Information
                </Typography>
            </Box>

            <TextField
                label="Number of Human Victims"
                type="number"
                value={count}
                onChange={handleCountChange}
                InputProps={{ inputProps: { min: 1 } }}
                fullWidth
                margin="normal"
            />

            {[...Array(count)].map((_, idx) => (
                <Box key={idx} mb={3} p={2} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
                    <Typography variant="subtitle1" gutterBottom>
                        Victim #{idx + 1}
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <TextField label="Name" fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField label="Weight (lbs)" type="number" fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Box display="flex" gap={1}>
                                <FormControlLabel control={<Checkbox />} label="M" />
                                <FormControlLabel control={<Checkbox />} label="F" />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                label="Birthdate"
                                type="date"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField label="Guardian (if Minor)" fullWidth />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Address (If not a street address, give directions)"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField label="City" fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField label="State" fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField label="Zip" fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField label="Phone" fullWidth placeholder="(123) 456-7890" />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField label="Alternate Phone" fullWidth placeholder="(123) 456-7890" />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField label="Email" type="email" fullWidth />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Wound Location & Severity"
                                fullWidth
                                multiline
                                rows={3}
                            />
                        </Grid>
                    </Grid>
                </Box>
            ))}
        </Box>
    );
}
